module.exports = __webpack_public_path__ + "img/courses_empty02.7f78a71.png";